// 項目変更履歴と評価変更履歴のテーブルのスタイル
export const tableStyle = {
    margin: "0 10px",
    width: "1200px",
    borderInline: "1px solid black",
    tableLayout: "fixed", // セル幅を固定して横幅制御を強化
};

export const tableHeaderDateStyle = {
    width: "135px",
    minWidth: "135px",
    maxWidth: "135px",
    height: "50px",
    color: "#fff",
    border: "1px solid black",
    backgroundColor: "#00CC5B",
    padding: "4px",
};

export const tableHeaderNameStyle = {
    width: "100px",
    minWidth: "100px",
    maxWidth: "100px",
    height: "50px",
    color: "#fff",
    border: "1px solid black",
    backgroundColor: "#00CC5B",
    padding: "4px",
};

export const tableHeaderStyle = {
    width: "180px",
    minWidth: "180px",
    maxWidth: "180px",
    height: "50px",
    color: "#fff",
    border: "1px solid black",
    backgroundColor: "#00CC5B",
    padding: "4px",
};

export const tableHeaderSmallStyle = {
    width: "15px",
    minWidth: "15px",
    maxWidth: "15px",
    height: "50px",
    color: "#fff",
    border: "1px solid black",
    backgroundColor: "#00CC5B",
    padding: "4px",
};

export const tableCellSmallStyle = {
    width: "15px",
    minWidth: "15px",
    maxWidth: "15px",
    border: "1px solid black",
    padding: "4px",
    wordBreak: "break-all",
    wordWrap: "break-word",
    overflowWrap: "break-word",
    overflow: "hidden",
};

export const tableCellDateStyle = {
    width: "135px",
    minWidth: "135px",
    maxWidth: "135px",
    border: "1px solid black",
    padding: "4px",
};

export const tableCellNameStyle = {
    width: "100px",
    minWidth: "100px",
    maxWidth: "100px",
    border: "1px solid black",
    padding: "4px",
};

export const tableCellWhiteSpace = {
    width: "180px",
    minWidth: "180px",
    maxWidth: "180px",
    border: "1px solid black",
    whiteSpace: "pre-wrap",
    padding: "4px",
    wordBreak: "break-all",
    wordWrap: "break-word",
    overflowWrap: "break-word",
    overflow: "hidden",
};

export const tableCellStyle = {
    width: "185px",
    minWidth: "185px",
    maxWidth: "185px",
    border: "1px solid black",
    whiteSpace: "pre-wrap",
    padding: "4px",
    wordBreak: "break-all",
    wordWrap: "break-word",
    overflowWrap: "break-word",
    overflow: "hidden",
};

export const tableCellStyleWhiteSpace = {
    width: "185px",
    minWidth: "185px",
    maxWidth: "185px",
    height: "50px",
    border: "1px solid black",
    whiteSpace: "pre-wrap",
    padding: "4px",
    wordBreak: "break-all",
    wordWrap: "break-word",
    overflowWrap: "break-word",
    overflow: "hidden",
};

export const commentHeaderStyle = {
    width: "900px",
    height: "50px",
    color: "#fff",
    border: "1px solid black",
    backgroundColor: "#00CC5B",
};

export const commentCellStyle = {
    width: "900px",
    minWidth: "900px",
    maxWidth: "900px",
    border: "1px solid black",
    padding: "4px",
    whiteSpace: "pre-wrap",
    wordBreak: "break-all",
    wordWrap: "break-word",
    overflowWrap: "break-word",
    overflow: "hidden",
};
